import React from "react";
import { TenderedProjectDto } from "../../../types/projectTypes";
import { Box, Button, Card, CardActions, CardContent, Divider, Typography } from "@mui/material";
import ProjectChip from "./ProjectChip";
import { Link, useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import { hasDayPassed } from "../../../utils/dateUtils";

/**
 * Component for a tendered project card
 * @param projectID - ID of the project
 * @param projectName - Name of the project
 * @param projectStatus - Status of the project
 * @param applicationEnd1 - First Deadline for applications
 * @param applicationEnd2 - Second Deadline for applications
 * @returns - A card component for a tendered project
 */
const TenderedProjectCard = ({
  projectId,
  projectName,
  status,
  applicationEnd1,
  applicationEnd2,
}: TenderedProjectDto) => {
  const navigate = useNavigate();

  const isButtonDisabled = applicationEnd2
    ? hasDayPassed(applicationEnd2)
    : applicationEnd1
    ? hasDayPassed(applicationEnd1)
    : true;

  const handleApply = () => {
    navigate(`/projekte/projektbewerbung/${projectId}`);
  };

  const handleMoreInformation = () => {
    navigate(`/projekte/${projectId}`);
  };

  return (
    <Card sx={{ maxWidth: 350 }} key={`Projekt-${projectId}`}>
      <CardContent sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Box sx={{ mb: 1 }}>
          <ProjectChip status={status} />
        </Box>
        <Link to={`/projekte/${projectId}`} style={{ textDecoration: "none", color: "black" }}>
          <Typography fontWeight="bold" sx={{ minHeight: "80px", height: "100%" }}>
            {projectName}
          </Typography>
        </Link>
        <Divider />
        {applicationEnd1 ? (
          <Box
            sx={{
              backgroundColor: "#aeb0b2",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              borderRadius: 1.5,
              marginTop: 2,
              padding: 0.5,
            }}
          >
            <Typography color="#000" fontSize={14}>
              Bewirb dich jetzt bis zum:{" "}
              <span style={{ fontWeight: "bold" }}>
                {applicationEnd2
                  ? dayjs(applicationEnd2).format("DD.MM.YYYY HH:mm")
                  : dayjs(applicationEnd1).format("DD.MM.YYYY HH:mm")}
              </span>
            </Typography>
          </Box>
        ) : null}
      </CardContent>
      <CardActions sx={{ justifyContent: "space-between" }}>
        <Button variant="contained" disabled={isButtonDisabled} onClick={handleApply}>
          Bewerben
        </Button>
        <Button variant="outlined" onClick={handleMoreInformation}>
          Mehr Informationen
        </Button>
      </CardActions>
    </Card>
  );
};

export default TenderedProjectCard;
